import { render, staticRenderFns } from "./SettingsNotificationsFilters.vue?vue&type=template&id=1b66fa0c&scoped=true&"
import script from "./SettingsNotificationsFilters.vue?vue&type=script&lang=js&"
export * from "./SettingsNotificationsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b66fa0c",
  null
  
)

export default component.exports